import React from 'react'
import queryString from "query-string";
import { Link } from 'react-router-dom'
import { ItemTimerCard } from '../Assessment/AssessTest'
import {connect} from 'react-redux';

import * as assessmentActionCreators from "../../redux/modules/assessment";
import isLicenseExpired from '../../helpers/users/licenses/isLicenseExpired'
import { bindActionCreators } from "redux";

class AssessmentHeader extends React.Component {
   constructor(props){
       super(props);
       this.state ={timeRemaining: 0};
   }
    
  render(){ 
    const {search,  subTestSetId, timeRemaining} = this.props;
    const qs = queryString.parse(search);
    const complete = this.props.userAssessment && this.props.userAssessment.destructuredSubtests && this.props.userAssessment.destructuredSubtests[subTestSetId].complete  ? this.props.userAssessment.destructuredSubtests[subTestSetId].complete : qs.g;
  const directionsQS = {
    ...qs,
    m: 'directions',
  }

  const directionsLink = queryString.stringify(directionsQS)


  const overviewQS = {
    ...qs,
    item: 'overview'
  }
  const overviewLink = queryString.stringify(overviewQS)

  function getSubmitQueryString(qs) {
    let queryObj = Object.assign({}, qs)
    queryObj.m = 'submit'
    return queryString.stringify(queryObj)
  }

  
  const submitQueryString = getSubmitQueryString(qs)

  function timerDanger() {
    if (timeRemaining < 300000 && timeRemaining >= 60000) {
      return ' warning';
    } else if (timeRemaining < 60000) {
      return ' danger';
    } else {
      return ''
    }
  }


  return (
    <div className="assessment-test-header assessment-header-bar no-gutters row">
             <div className="assessment-header-left test-resources">
              <div className="mr-3" style={{ "color": "white" }}>Text Size </div>
              <div style={{ "color": "lightGrey", "cursor": "pointer" }}  className="mr-2"><i onClick={this.props.onFontMagnify} className="fa fa-plus-circle" /></div>
              <div style={{ "color": "lightGrey", "cursor": "pointer" }}  className="mr-3"><i onClick={this.props.onFontdeMagnify} className="fa fa-minus-circle" /></div>
              <div className="view-directions">
                <p>
                  <Link to={`?${directionsLink}`}>
                    🔎 View Directions
                  </Link>
                </p>
              </div>
             </div>
            <div className="assessment-header-right test-resources">
            <div className={`test-timer-container${timerDanger()}`}>
               {
                <ItemTimerCard
                     timeRemaining={timeRemaining}
                     completed={complete}
                     expired={this.props.userAssessment ? isLicenseExpired(this.props.user.role, this.props.userAssessment.assessmentSetId, this.props.userLicenses) : false}
                   />
                  
               }
              </div>
              {!complete && !isLicenseExpired(this.props.user.role, this.props.userAssessment.assessmentSetId, this.props.userLicenses) &&
                <Link className='submit-test header-assessment-button' to={`?${submitQueryString}`}>Submit Test</Link>
              }
              {complete || isLicenseExpired(this.props.user.role, this.props.userAssessment.assessmentSetId, this.props.userLicenses) &&
                <Link className='back-to-overview header-assessment-button' to={`?${overviewLink}`}>Back to Overview</Link>
              }
            </div>
     
           </div>
  );
        }
}



export default connect(
    (state) => ({
      items: state.assessment.items,
        userAssessment: state.assessment.userAssessment,
        timeRemaining: state.assessment.timeRemaining,
        userLicenses : state.licenses.userlicenses,
        user: state.users.testUser,
    }),
    dispatch =>
    bindActionCreators(
      { ...assessmentActionCreators },
      dispatch
    )
)(AssessmentHeader)


// WEBPACK FOOTER //
// ./src/components/Header/AssessmentHeader.js